/*
  AE free-delivery add-ons (owner request, 23 Oct 2026; tools/free_delivery_nudge.py).
  sections/ae-free-delivery-addons.liquid picks the items server-side. This script only:
  - fills the add-to-cart popup after each add, and refreshes the cart-page copy when the cart
    changes (Section Rendering API);
  - adds a suggestion in one click (/cart/add) and swaps in the re-rendered sections, the same
    way Dawn's cart.js and cart-notification.js do.
  Without it, each "Add" is a plain form post to /cart/add and Shopify shows the cart page.
*/
(() => {
  if (window.aeFreeDeliveryAddons) return;
  window.aeFreeDeliveryAddons = true;

  const SECTION = 'ae-free-delivery-addons';
  const SOURCE = 'ae-free-delivery-addons';
  // Hidden line-item tag (D-011) so orders that used the strip can be counted; "_" keeps it out of view.
  const TAG = { _ae_addon: 'free-delivery' };
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';
  // Dawn declares PUB_SUB_EVENTS with const, so it is a global binding but not a window property.
  const EVENTS = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;

  const popup = () => document.getElementById('ae-fd-popup');
  const cartCopy = () => document.querySelector('#MainContent [data-ae-fd]');
  const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

  // Put the freshly rendered strip into container, keeping an existing strip element (and its live region).
  function paint(container, html) {
    const fresh = html && parse(html, '[data-ae-fd]');
    if (!container || !fresh) return;
    const current = container.matches('[data-ae-fd]') ? container : container.querySelector('[data-ae-fd]');
    if (current) {
      current.className = fresh.className;
      current.innerHTML = fresh.innerHTML;
    } else {
      container.replaceChildren(fresh);
    }
  }

  function replaceSection(id, html) {
    const target = document.getElementById(id);
    const fresh = html && parse(html, '.shopify-section');
    if (target && fresh) target.innerHTML = fresh.innerHTML;
  }

  async function refresh(container) {
    if (!container) return;
    try {
      const response = await fetch(`${ROOT}?section_id=${SECTION}`);
      if (response.ok) paint(container, await response.text());
    } catch (error) {}
  }

  if (typeof subscribe === 'function' && EVENTS) {
    subscribe(EVENTS.cartUpdate, (event) => {
      if (event && event.source === SOURCE) return;
      const mount = popup();
      if (mount && event && event.source === 'product-form') {
        mount.replaceChildren(); // never show the previous basket's gap while the new one loads
        refresh(mount);
      }
      refresh(cartCopy());
    });
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest && event.target.closest('[data-ae-fd-form]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button');
    const inPopup = Boolean(form.closest('#ae-fd-popup'));
    const footer = !inPopup && document.getElementById('main-cart-footer');
    const sections = [SECTION, 'cart-icon-bubble', inPopup ? 'cart-notification-button' : footer && footer.dataset.id];
    button.disabled = true;

    try {
      const response = await fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(form.elements.id.value), quantity: 1, properties: TAG }],
          sections: sections.filter(Boolean).join(','),
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || '');

      const rendered = state.sections || {};
      replaceSection('cart-icon-bubble', rendered['cart-icon-bubble']);
      if (inPopup) replaceSection('cart-notification-button', rendered['cart-notification-button']);
      if (footer && rendered[footer.dataset.id]) {
        const target = footer.querySelector('.js-contents');
        const fresh = parse(rendered[footer.dataset.id], '.js-contents');
        if (target && fresh) target.innerHTML = fresh.innerHTML;
        footer.classList.remove('is-empty');
      }
      paint(inPopup ? popup() : cartCopy(), rendered[SECTION]);
      // Dawn's cart page re-renders its line items on this event; the AE motivator bar listens too.
      if (typeof publish === 'function' && EVENTS) publish(EVENTS.cartUpdate, { source: SOURCE, cartData: state });
    } catch (error) {
      button.disabled = false;
      const note = form.closest('.ae-fd__item') && form.closest('.ae-fd__item').querySelector('.ae-fd__note');
      if (note) note.textContent = error.message || 'Sorry, that could not be added. Please try again.';
    }
  });
})();
